module.exports = __webpack_public_path__ + "site/img/renew.4b3013ba.png";